import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Message, Thread } from 'app/messages/message-service/message.model';
import { environment } from 'environments/environment';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { cloneDeep } from 'lodash';
import * as _ from 'lodash';
import { LenderUser } from 'app/models/dto/lender-user.model';


@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit, OnChanges {

  @Input() thread: Thread;
  @Input() message: Message;
  @Input() borrower: Borrower;
  @Input() user: LenderUser;
  @Input() messageIndex: number;
  @Input() messageCreateType: string;
  @Input() isFirst: boolean;
  @Input() isLast: boolean;
  @Input() messageGroup: boolean;

  @Output() messageRead = new EventEmitter;
  @Output() emailCreate = new EventEmitter;
  @Output() openMessageGroup = new EventEmitter;

  lenderUserFullName = '';

  constructor() { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.thread) {
      this.declareReadMessages(this.thread.messages);
      this.checkForBccRecipients(this.thread.messages);
      this.formatMessagePreviews(this.thread.messages);
    }
    if (changes.user) {
      if (!!this.user) {
        this.lenderUserFullName = this.user.fullName ? this.user.fullName : '';
      }
    }
  }

  declareReadMessages(messages: Message[]) {
    _.map(messages, function(message) {
      message.recipientRecords ?
        _.map(message.recipientRecords, (recipient: any) => {
          if (recipient.opens) {
            message.opened = true;
            message.numberOfViews ? message.numberOfViews++ : message.numberOfViews = 1;
          } else {
            message.opened = false;
          }
        }) : message.opened = false;
    });
  }

  formatMessagePreviews(messages: Message[]) {
    _.map(messages, message => {
      message.previewText = message?.html?.replace(/(<[^>]*>)|\n/g, '');
    });
  }

  checkForBccRecipients(messages: Message[]) {
    _.map(messages, function(message: Message) {
      if (message.recipientRecords) {
        const tempBccArray = message.recipientRecords.filter(recipient => recipient.bcc === 1);
        message.bccRecipients = cloneDeep(tempBccArray);
      }
    });
  }

  handleMessageRead(message: Message) {
    this.messageRead.emit(message);
  }

  handleEmailCreate(message: Message): void {
    this.emailCreate.emit(message);
  }

  isToday(createdTimeStamp) {
    const timestampDate = new Date(createdTimeStamp * 1000);
    const today = new Date();
    return (today.getDate() === timestampDate.getDate()
      && today.getMonth() === timestampDate.getMonth()
      && today.getFullYear() === timestampDate.getFullYear());
  }

  downloadAttachment(attachmentId: number): void {
    const url = `${environment.API_URL}/document/${attachmentId}?stream=1&method=attachment`;
    window.location.href = url;
  }

  handleOpenMessages() {
    this.openMessageGroup.emit();
  }

}
